import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import ReactDOM from 'react-dom';

import { msalConfig } from './authConfig';
import App from './components/App';
import './index.css';

async function initializeMsal() {
  try {
    const msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();

    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    function setDatadogRumUser(account) {
      if (account && window.DD_RUM && typeof window.DD_RUM.setUser === 'function') {
        const userData = {
          id: account.localAccountId,
          is_internal: account.username.endsWith('@flix.com'),
        };
        window.DD_RUM.setUser(userData);
      }
    }

    const account = msalInstance.getActiveAccount();
    setDatadogRumUser(account);

    msalInstance.addEventCallback((event) => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          event.eventType === EventType.SSO_SILENT_SUCCESS) &&
        event.payload.account
      ) {
        msalInstance.setActiveAccount(event.payload.account);
        // Set Datadog RUM user again after login
        setDatadogRumUser(event.payload.account);
      }
    });

    return msalInstance;
  } catch (error) {
    console.error('Error initializing MSAL:', error);
    throw error; // Re-throw the error to propagate it upwards
  }
}

initializeMsal()
  .then((msalInstance) => {
    ReactDOM.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>,
      document.getElementById('root')
    );
  })
  .catch((error) => {
    console.error('Error rendering React application:', error);
  });
